import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает список новостей для карточки поста
 */
export const selectNews = ({ postCardNew: { news } }: IApplicationState) => news;
